import { sessionState } from "@/state"
import Environment from "@/model/flow/Environment"
import GoogleAnalyticsScreenTitles from "@/model/google/GoogleAnalyticsScreenTitles"

class GoogleAnalyticsService {
    setUpGoogleAnalytics() {
        const env = sessionState.environment
        const gtagId = "G-5J2B0GBQCN" // Aspen Production ID
        // const gtagId = "G-SVMM59Q3JN" // Versatile Test ID

        if (env === Environment.PROD) {
            //Add Global site tag (gtag.js) - Google Analytics
            const globalGtagScript = document.createElement("script")
            globalGtagScript.setAttribute("src", `https://www.googletagmanager.com/gtag/js?id=${gtagId}`)
            globalGtagScript.setAttribute("title", "globalGtagScript")
            document.head.appendChild(globalGtagScript)

            //Add Gtag Config script
            const gtagConfigScript = document.createElement("script")
            gtagConfigScript.setAttribute("src", `${import.meta.env.BASE_URL}js/gtag-config.js`)
            gtagConfigScript.setAttribute("id", "gtag-config")
            gtagConfigScript.setAttribute("title", "gtagConfig")
            gtagConfigScript.setAttribute("gtagId", `${gtagId}`)
            document.head.appendChild(gtagConfigScript)
        }
    }

    isGoogleAnalyticsEnabled() {
        if (sessionState.environment !== Environment.PROD) return false
        return typeof gtag !== "undefined" && typeof gtag === "function"
    }

    buttonEvent(button_event_name, button_event_label) {
        if (this.isGoogleAnalyticsEnabled()) {
            window.gtag("event", button_event_name, {
                event_category: "Button",
                event_label: button_event_label,
            })
        }
    }

    sideBySideEvent(event_name, providersResponse) {
        let providers = []
        providersResponse.forEach(provider => {
            providers.push(provider.providerId)
        })

        window.gtag("event", "side_by_side", {
            event_category: "Screen",
            event_label: "Side By Side",
            lender_1: providers[0],
            lender_2: providers[1],
        })
    }

    iFrameLoaded(event_name, lender) {
        window.gtag(event_name, "iframe", {
            event_category: "Screen",
            event_label: "iframe",
            lender: lender,
        })
    }

    pageView(path, time) {
        if (this.isGoogleAnalyticsEnabled()) {
            const screenName = this.toGoogleScreenName(path)

            window.gtag("event", "screen_view", {
                app_name: "Aspen Apply",
                screen_name: screenName,
                time_spent: time,
            })
        }
    }

    toGoogleScreenName(path) {
        let endPath = path?.path ? this.findEndPath(path.path) : undefined

        // create enum for return string
        switch (endPath) {
            case "approved":
                return GoogleAnalyticsScreenTitles.APPROVED
            case "apply":
                return GoogleAnalyticsScreenTitles.APPLY
            case "checkCalifornia":
                return GoogleAnalyticsScreenTitles.CHECK_CALIFORNIA
            case "declined":
                return GoogleAnalyticsScreenTitles.DECLINED
            case "paymentPlans":
                return GoogleAnalyticsScreenTitles.PAYMENT_PLANS
            case "paymentPlanReview":
                return GoogleAnalyticsScreenTitles.PAYMENT_PLAN_REVIEW
            case "paymentPlansView":
                return GoogleAnalyticsScreenTitles.PAYMENT_PLANS_VIEW
            case "pending":
                return GoogleAnalyticsScreenTitles.PENDING
            case "plans":
                return GoogleAnalyticsScreenTitles.PLANS
            case "prequalAgree":
                return GoogleAnalyticsScreenTitles.PREQUAL_AGREE
            case "start":
                return GoogleAnalyticsScreenTitles.START
            case "terms":
                return GoogleAnalyticsScreenTitles.TERMS
            default:
                return endPath
        }
    }

    findEndPath(path) {
        const segments = path.split("/")
        const lastSegment = segments.pop()
        return lastSegment || path
    }
}

export default GoogleAnalyticsService
